import { FaCheck } from 'react-icons/fa';

function CoachingPlanSection({ buyLink, onBuyClick }) {
  const weeks = [
    {
      number: "1️⃣",
      title: "Week 1",
      items: [
        "Complete Payment Recovery System",
        "Positive Cash Flow Mindset",
        "Zero Bad Debt in 6 Months"
      ]
    },
    {
      number: "2️⃣",
      title: "Week 2",
      items: [
        "Pani Puri Model",
        "No Part Payments Culture",
        "Per Invoice Payment System"
      ]
    },
    {
      number: "3️⃣",
      title: "Week 3",
      items: [
        "Working on Advance Payments",
        "Advance Invoicing",
        "Advance Follow-Up System"
      ]
    },
    {
      number: "4️⃣",
      title: "Week 4",
      items: [
        "Credit Policy",
        "The C3 Formula",
        "Credit Terms",
        "Credit Limits",
        "Background / CIBIL Check"
      ]
    },
    {
      number: "5️⃣",
      title: "Week 5",
      items: [
        "Client Filtration",
        "Client ROI System (Per Invoice Profit)",
        "Fraud Prevention",
        "Credit Insurance"
      ]
    },
    {
      number: "6️⃣",
      title: "Week 6",
      items: [
        "Payment Recovery Meetings",
        "Cheque Return Handling",
        "Outsourcing Recoveries"
      ]
    },
    {
      number: "7️⃣",
      title: "Week 7",
      items: [
        "Hiring & Training of Recovery Team"
      ]
    },
    {
      number: "8️⃣",
      title: "Week 8",
      items: [
        "Dead Stock Liquidation",
        "Fast Moving Strategy",
        "Cash Flow Management"
      ]
    }
  ];

  return (
    <section className="relative py-24 px-4 sm:px-8 bg-slate-800 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        {/* CTA Button */}
        <div className="text-center mb-14">
          <button 
            onClick={onBuyClick}
            className="inline-block bg-gradient-to-r from-amber-400 via-amber-500 to-orange-500 text-slate-900 px-12 sm:px-20 py-4 sm:py-5 rounded-xl text-lg sm:text-2xl font-extrabold shadow-[0_10px_20px_-5px_rgba(251,191,36,0.4)] hover:shadow-[0_20px_30px_-8px_rgba(251,191,36,0.5)] hover:-translate-y-0.5 transition-all duration-200 tracking-wide cursor-pointer"
          >
            Book a call →
          </button>
        </div>

        {/* Title */}
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-amber-400 text-center mb-4 drop-shadow-lg">
          🎓 8-Week Credit Control & Payment Recovery Coaching Plan
        </h2>
        <p className="text-lg sm:text-xl lg:text-2xl text-slate-400 text-center mb-12 max-w-3xl mx-auto font-medium">
          A structured week-by-week program to transform your payment recovery process
        </p>

        {/* Weeks Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5 lg:gap-6 max-w-[1400px] mx-auto">
          {weeks.map((week, index) => (
            <div 
              key={index}
              className="group relative bg-gradient-to-br from-slate-800 to-slate-900 rounded-2xl p-5 sm:p-6 lg:p-8 text-center border border-amber-500/20 hover:border-amber-500/40 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_25px_-5px_rgba(0,0,0,0.4),0_8px_10px_-6px_rgba(0,0,0,0.4)] overflow-hidden"
            >
              {/* Top Border Animation */}
              <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-amber-400 to-orange-500 scale-x-0 origin-left group-hover:scale-x-100 transition-transform duration-300"></div>
              
              {/* Week Number */}
              <div 
                className="text-5xl sm:text-6xl mb-2 animate-bounce"
                style={{ animationDelay: `${index * 0.2}s`, animationDuration: '3s' }}
              >
                {week.number}
              </div>

              {/* Week Title */}
              <div className="text-2xl sm:text-3xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-orange-500 mb-4">
                {week.title}
              </div>

              {/* Items List */}
              <ul className="text-left space-y-3">
                {week.items.map((item, itemIndex) => (
                  <li 
                    key={itemIndex}
                    className="flex items-start gap-3 text-slate-200 font-medium text-base sm:text-lg"
                  >
                    <FaCheck className="text-amber-400 mt-1 flex-shrink-0" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CoachingPlanSection;
